var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.5498 21.125C48.9248 9.575 38.8498 4.375 29.9998 4.375C29.9998 4.375 29.9998 4.375 29.9748 4.375C21.1497 4.375 11.0498 9.55 8.42475 21.1C5.49975 34 13.3998 44.925 20.5498 51.8C23.1998 54.35 26.5998 55.625 29.9998 55.625C33.3997 55.625 36.7998 54.35 39.4248 51.8C46.5748 44.925 54.4748 34.025 51.5498 21.125ZM29.9998 33.65C25.6497 33.65 22.1248 30.125 22.1248 25.775C22.1248 21.425 25.6497 17.9 29.9998 17.9C34.3498 17.9 37.8747 21.425 37.8747 25.775C37.8747 30.125 34.3498 33.65 29.9998 33.65Z",
    fill: "#D11018"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlace);
export default __webpack_public_path__ + "static/media/Place.049c179f1837b1bfdf2a9f307dfeb83a.svg";
export { ForwardRef as ReactComponent };